/**
 * Pub/Sub module.
 * @module pubSub
 */

let messages = {};

const pubSub = {
  publish: (message, data) => {
    // check if there are even messages
    if (Object.keys(messages).length === 0 && messages.constructor === Object) return false;

    // check if message exists
    if (messages[message] === undefined) return false;

    // check if message has subscribers
    if (Object.keys(messages[message]).length === 0) return false;

    // call message handler
    const handlers = Object.keys(messages[message]).map(handler => messages[message][handler]);

    handlers.forEach((handler) => {
      handler(data);
    });

    return true;
  },

  subscribe: (message, handler) => {
    const token = `uid_${String(Math.floor(Math.random() * (9999)) + 1)}`;

    // message is not registered yet
    if (!(message in messages)) {
      messages[message] = {};
    }

    // assign handler to message and token
    messages[message][token] = handler;

    // return token for unsubscribing
    return token;
  },

  unsubscribe: (token) => {
    Object.keys(messages).forEach((message) => {
      Object.keys(messages[message]).forEach((key) => {
        if (key === token) {
          delete messages[message][token];
        }
      });
    });
  },

  clearAllSubscriptions: () => {
    messages = {};
  },
};

export default pubSub;



// WEBPACK FOOTER //
// ./assets/js/components/pubSub.js